<template>
	<b-modal
		id="auth-modal"
		v-model="isVisible"
		modal-class="auth-modal"
		title-class="auth-title"
		hide-footer
		:title="authType"
		size="xl"
	>
		<div class="row d-flex justify-content-between">
			<div class="col-12 col-md-12 col-lg-6 py-3 py-md-4 pt-lg-2 pb-lg-3 border-lg-right">
				<div class="logo-block d-none d-md-flex flex-column">
					<img src="/frontimg/SKOLKOVO_15.png" alt="SKOLKOVO Logo">
					<template v-if="type === TYPE.LOGIN">
						<div v-if="loginType === LOGIN_TYPES.EMAIL" />
						<div v-else>
							{{ $t('authDescription') }}
						</div>
					</template>
					<template v-if="type === TYPE.REGISTRATION">
						{{ $t('authDescription') }}
					</template>
				</div>
			</div>
			<div
				class="col-12 col-md-12 col-lg-6 py-3 py-md-4 pt-lg-2 pb-lg-3"
			>
				<div v-if="isModalForSkolkovoId && (type === TYPE.LOGIN || type === TYPE.LOGIN_SIMPLE_WINDOW)" class="row d-flex justify-content-center">
					<div class="col-12 col-md-10 col-lg-10 d-flex flex-column align-items-center">
						<div v-if="!isResetPassword" class="title mb-3">
							{{ $t('auth') }}
						</div>
						<div v-else class="title mb-3">
							{{ $t('accessRecovery') }}
						</div>
						<template>
							<a :href="skolkovoIdAuthUrl" class="btn btn-primary mb-3">Войти через Skolkovo ID</a>
							<div class="mb-3 text-muted">
								или
							</div>
							<b-button
								variant="link"
								class="p-0"
								@click="showRegistration"
							>
								{{ $t('createAccount') }}
							</b-button>
						</template>
					</div>
				</div>
				<template v-else-if="type === TYPE.LOGIN || type === TYPE.LOGIN_SIMPLE_WINDOW">
					<div class="row d-flex justify-content-center">
						<div class="col-12 col-md-10 col-lg-10">
							<div v-if="!isResetPassword" class="title mb-3">
								{{ $t('auth') }}
							</div>
							<div v-else class="title mb-3">
								{{ $t('accessRecovery') }}
							</div>
							<template
								v-if="type !== TYPE.LOGIN_SIMPLE_WINDOW"
							>
								<div class="mb-3">
									<b-button
										variant="link"
										class="p-0"
										disabled
										@click="showLogin"
									>
										{{ $t('signIn') }}
									</b-button>
									|
									<b-button
										variant="link"
										class="p-0"
										@click="showRegistration"
									>
										{{ $t('createAccount') }}
									</b-button>
								</div>
								<div v-if="!isResetPassword" class="mb-3">
									<b-button
										variant="link"
										class="p-0"
										:disabled="loginType === LOGIN_TYPES.EMAIL"
										@click="toggleLogin(LOGIN_TYPES.EMAIL)"
									>
										{{ $t('loginWithPassword') }}
									</b-button>
									|
									<b-button
										variant="link"
										class="p-0"
										:disabled="loginType === LOGIN_TYPES.CODE"
										@click="toggleLogin(LOGIN_TYPES.CODE)"
									>
										{{ $t('loginWithCode') }}
									</b-button>
								</div>
							</template>
						</div>
					</div>
					<form @submit.prevent="onSubmit">
						<div class="row d-flex justify-content-center">
							<div class="col-12 col-md-10 col-lg-10">
								<div class="form-row">
									<div
										class="form-group col-12"
										:class="{ 'form-group--error': form.errors.email }"
									>
										<input
											id="login"
											v-model.trim="form.fields.email"
											name="login"
											:placeholder="$t('authEmail')"
											type="text"
											class="form-control rounded-0 required"
											required
											autocomplete="email"
											:disabled="form.isKoiUserRecognized || form.isRegisteredUserRecognized"
										>
										<div v-if="form.errors.email" class="error">
											<div v-for="msg in form.errors.email" :key="msg">
												{{ msg }}
											</div>
										</div>
									</div>
									<div
										v-if="!isResetPassword && loginType === LOGIN_TYPES.EMAIL"
										class="form-group col-12"
										:class="{ 'form-group--error': form.errors.password }"
									>
										<input
											id="password"
											v-model.trim="form.fields.password"
											name="password"
											:placeholder="$t('password')"
											type="password"
											class="form-control rounded-0 required"
											required
											autocomplete="current-password"
										>
										<div v-if="form.errors.password" class="error">
											<div v-for="msg in form.errors.password" :key="msg">
												{{ msg }}
											</div>
										</div>
									</div>
									<div
										v-if="!isResetPassword && loginType === LOGIN_TYPES.CODE && stage === 1"
										class="form-group col-12"
										:class="{ 'form-group--error': form.errors.code }"
									>
										<input
											id="code"
											v-model.trim="form.fields.code"
											name="code"
											:placeholder="$t('code')"
											type="number"
											class="form-control rounded-0 required"
											required
										>
										<div v-if="form.errors.code" class="error">
											<div v-for="msg in form.errors.code" :key="msg">
												{{ msg }}
											</div>
										</div>
									</div>
									<div v-if="form.message" class="success form-group col-12">
										<p>{{ form.message }}</p>
									</div>
									<div v-if="!isResetPassword && loginType === LOGIN_TYPES.EMAIL" class="form-group col-12">
										<b-button
											v-b-popover.hover.top="$t('recoverHover')"
											variant="link"
											class="p-0"
											:disabled="form.sending"
											@click="toggleToResetPassword"
										>
											{{ $t('forgotPassword') }}
										</b-button>
									</div>
								</div>
								<div class="form-row">
									<div class="col-12">
										<b-button
											v-if="!isResetPassword && (loginType === LOGIN_TYPES.EMAIL || stage === 1)"
											variant="primary"
											type="submit"
											:disabled="form.sending"
										>
											{{ $t('signIn') }}
										</b-button>
										<b-button
											v-if="isResetPassword"
											variant="primary"
											type="submit"
											@click="forgotPassword"
										>
											{{ $t('continue') }}
										</b-button>
										<b-button
											v-if="loginType === LOGIN_TYPES.CODE && stage === 0"
											variant="primary"
											type="button"
											:disabled="form.sending"
											@click="codeGenerate"
										>
											{{ $t('continue') }}
										</b-button>
										<b-button
											v-if="isResetPassword"
											variant="outline-primary"
											type="submit"
											@click="returnToAuth"
										>
											{{ $t('return') }}
										</b-button>
										<span
											v-if="form.error"
											class="overflow-auto error mb-3"
										>
											{{ form.error }}
										</span>
										<span
											v-else-if="loginType === LOGIN_TYPES.CODE && stage === 1"
											class="overflow-auto success mb-3"
											style="font-size: 80%;"
										>
											Письмо отправлено
										</span>
									</div>
								</div>
							</div>
						</div>
					</form>
					<!-- <div v-if="!isResetPassword && loginType === LOGIN_TYPES.EMAIL" class="row d-flex justify-content-center mt-4">
						<div class="col-12 col-md-10 col-lg-10">
							<p class="mb-0">
								{{ $t('loginWith') }}
							</p>
							<div class="social-login mt-1">
								<a
									v-for="provider in providers"
									:key="provider.name"
									:href="provider.link"
									class="btn btn-icon btn-social mr-2"
									:class="provider.class"
								>
									<i :class="provider.iconClass" />
								</a>
							</div>
						</div>
					</div> -->
				</template>
				<template v-if="type === TYPE.REGISTRATION">
					<div v-if="registrationType === null">
						<div class="row d-flex justify-content-center">
							<div class="col-12 col-md-10 col-lg-10">
								<div class="title mb-3">
									{{ $t('auth') }}
								</div>
								<div class="mb-3">
									<b-button
										variant="link"
										class="p-0"
										@click="showLogin"
									>
										{{ $t('signIn') }}
									</b-button>
									|
									<b-button
										variant="link"
										class="p-0"
										disabled
										@click="showRegistration"
									>
										{{ $t('createAccount') }}
									</b-button>
								</div>
								<b-button
									variant="primary"
									class="m-1"
									@click="personRegisterHandler"
								>
									<b>{{ $t('person') }}</b>
								</b-button>
								<b-button
									v-if="$i18n.locale === 'ru'"
									variant="primary"
									class="m-1"
									@click="registrationType = REGISTRATION_TYPES.ENTITY"
								>
									<b>{{ $t('corporate') }}</b>
								</b-button>
							</div>
						</div>
					</div>
					<div v-else-if="registrationType === REGISTRATION_TYPES.DEFAULT">
						<form @submit.prevent="onSubmit">
							<div class="row d-flex justify-content-center">
								<div class="col-12 col-md-10 col-lg-10">
									<div class="title mb-3">
										{{ $t('createAccountPerson') }}
									</div>
									<div class="mb-3">
										<b-button
											variant="link"
											class="p-0"
											@click="showLogin"
										>
											{{ $t('signIn') }}
										</b-button>
										|
										<b-button
											variant="link"
											class="p-0"
											@click="changeRegistrationType"
										>
											{{ $t('createAccount') }}
										</b-button>
									</div>
									<div class="form-row auth-form">
										<div
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.first_name }"
										>
											<input
												id="first_name"
												v-model.trim="form.fields.first_name"
												name="first_name"
												:placeholder="$t('namePlaceholder')"
												type="text"
												class="form-control rounded-0 required"
												autocomplete="given-name"
											>
											<label v-if="form.errors.first_name" class="error" for="first_name">
												<div v-for="msg in form.errors.first_name" :key="msg">{{ msg }}</div>
											</label>
										</div>
										<div
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.last_name }"
										>
											<input
												id="last_name"
												v-model.trim="form.fields.last_name"
												name="last_name"
												:placeholder="$t('lastNamePlaceholder')"
												type="text"
												class="form-control rounded-0 required"
												autocomplete="family-name"
											>
											<label v-if="form.errors.last_name" class="error" for="last_name">
												<div v-for="msg in form.errors.last_name" :key="msg">{{ msg }}</div>
											</label>
										</div>
										<div
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.email }"
										>
											<input
												id="email"
												v-model.trim="form.fields.email"
												name="email"
												:placeholder="$t('emailField')"
												type="email"
												class="form-control rounded-0 required"
												required
												autocomplete="username"
											>
											<label v-if="form.errors.email" class="error" for="email">
												<div v-for="msg in form.errors.email" :key="msg">{{ msg }}</div>
											</label>
										</div>
										<div
											class="form-group col-12 auth-phone-class"
											:class="{
												'form-group--error':
													showPhoneValidationError,
											}"
										>
											<VuePhoneNumberInput
												id="phone"
												ref="phoneInput"
												v-model="mobilePhoneShort"
												name="phone"
												color="#000000"
												default-country-code="RU"
												:border-radius="0"
												:no-country-selector="false"
												:no-flags="true"
												:no-example="true"
												:show-code-on-list="true"
												:translations="{
													countrySelectorLabel: '',
													countrySelectorError: $t(
														'countrySelectorError'
													),
													phoneNumberLabel: $t('phoneNumberLabel'),
													example: $t('exampleEvent'),
												}"
												@update="phoneUpdate"
											/>
											<label
												v-if="showPhoneValidationError"
												class="error"
												for="phone"
											>{{ $t('fillPhoneMessage') }}</label>
										</div>
										<div
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.password }"
										>
											<input
												id="password"
												v-model.trim="form.fields.password"
												name="password"
												:placeholder="$t('password')"
												type="password"
												class="form-control rounded-0 required"
												required
												autocomplete="new-password"
											>
											<label v-if="form.errors.password" class="error" for="password">
												<div v-for="msg in form.errors.password" :key="msg">{{ msg }}</div>
											</label>
										</div>
										<div
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.password_confirmation }"
										>
											<input
												id="password_confirmation"
												v-model.trim="form.fields.password_confirmation"
												name="password_confirmation"
												:placeholder="$t('confirmPassword')"
												type="password"
												class="form-control rounded-0 required"
												required
												autocomplete="new-password"
											>
											<label
												v-if="form.errors.password_confirmation"
												class="error"
												for="password_confirmation"
											>
												<div
													v-for="msg in form.errors.password_confirmation"
													:key="msg"
												>{{ msg }}
												</div>
											</label>
										</div>
										<div
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.password_confirmation }"
										>
											<input
												id="birthday"
												v-model.trim="form.fields.birthday"
												name="birthday"
												:placeholder="$t('birthday')"
												type="date"
												class="form-control rounded-0 required"
												required
												autocomplete="birthday"
											>
											<label
												v-if="form.errors.birthday"
												class="error"
												for="password_confirmation"
											>
												<div
													v-for="msg in form.errors.birthday"
													:key="msg"
												>{{ msg }}
												</div>
											</label>
										</div>
										<div class="form-group col-12 custom-control custom-checkbox">
											<div v-if="showPersonalData" class="form-check mb-3">
												<input
													id="accept"
													v-model.trim="agreements.personal_data"
													v-model="form.fields.accept"
													name="accept"
													type="checkbox"
													class="rounded-0 required form-check-input custom-control-input"
													value="personal-data"
													required
													data-action="layout-auth-personal-data-processing-agreement"
												>
												<label class="custom-control-label form-check-label" for="accept">
													{{ $t('agreeWith') }}
													<a
														:href="`https://www.skolkovo.ru/static/personaldata_${$i18n.locale === 'ru' ? 'rus': 'eng'}.html`"
														target="_blank"
													>{{ $t('personalData') }}</a>
													<template v-if="form.errors.accept">
														<div v-for="msg in form.errors.accept" :key="msg">{{
															msg
														}}
														</div>
													</template>
												</label>
											</div>
											<div v-if="showMarketingEmails" class="form-check">
												<input
													id="marketing_emails"
													v-model.trim="agreements.marketing_emails"
													name="marketing_emails"
													type="checkbox"
													class="rounded-0 required form-check-input custom-control-input"
													value="marketing-emails"
													data-action="layout-auth-marketing-emails-agreement"
												>
												<label
													class="custom-control-label form-check-label"
													for="marketing_emails"
												>
													{{ $t('isAgreesToMarketingEmails') }}
												</label>
											</div>
										</div>
										<div
											class="form-group col-12 custom-control custom-checkbox"
										>
											<div class="form-check">
												<input
													id="need_register_loyalty"
													v-model.trim="form.fields.need_register_loyalty"
													name="need_register_loyalty"
													type="checkbox"
													class="rounded-0 required form-check-input custom-control-input"
													:value="1"
													data-action="layout-auth-loyalty-registration-agreement"
												>
												<label
													class="custom-control-label form-check-label"
													for="need_register_loyalty"
												>
													{{ $t('agreeWithLoyalty') }}
													<a href="https://sk.skolkovo.ru/storage/loyalty-legal.pdf" target="_blank">{{ $t('loyaltyLegal') }}</a>
													<template v-if="form.errors.need_register_loyalty">
														<div
															v-for="msg in form.errors.need_register_loyalty"
															:key="msg"
														>{{
															msg
														}}
														</div>
													</template>
												</label>
											</div>
										</div>
									</div>
									<div class="form-row">
										<div v-if="form.message" class="col-12 overflow-auto message mb-3">
											{{ form.message }}
										</div>
									</div>
									<div class="form-row">
										<div v-if="false" class="col-12">
											<div class="g-recaptcha" data-sitekey="recaptcha" />
										</div>
										<div class="col-12">
											<b-button
												variant="primary"
												type="submit"
												:disabled="form.sending || form.sent || !agreements.personal_data"
											>
												{{ $t('createAccount') }}
											</b-button>
											<span
												v-if="error"
												class="overflow-auto error mb-3"
											>
												{{ error }}
											</span>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div v-else-if="registrationType === REGISTRATION_TYPES.ENTITY">
						<form @submit.prevent="onSubmit">
							<div class="row d-flex justify-content-center">
								<div class="col-12 col-md-10 col-lg-10">
									<div class="title mb-3">
										{{ $t('createAccountCorporate') }}
									</div>
									<div class="mb-3">
										<b-button
											variant="link"
											class="p-0"
											@click="showLogin"
										>
											{{ $t('signIn') }}
										</b-button>
										|
										<b-button
											variant="link"
											class="p-0"
											@click="changeRegistrationType"
										>
											{{ $t('createAccount') }}
										</b-button>
									</div>
									<div class="form-row auth-form">
										<div
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.first_name }"
										>
											<input
												id="first_name"
												v-model.trim="form.fields.first_name"
												name="first_name"
												:placeholder="$t('adminName')"
												type="text"
												class="form-control rounded-0 required"
												autocomplete="given-name"
											>
											<label v-if="form.errors.first_name" class="error" for="first_name">
												<div v-for="msg in form.errors.first_name" :key="msg">{{ msg }}</div>
											</label>
										</div>
										<div
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.last_name }"
										>
											<input
												id="last_name"
												v-model.trim="form.fields.last_name"
												name="last_name"
												:placeholder="$t('adminLastName')"
												type="text"
												class="form-control rounded-0 required"
												autocomplete="family-name"
											>
											<label v-if="form.errors.last_name" class="error" for="last_name">
												<div v-for="msg in form.errors.last_name" :key="msg">{{ msg }}</div>
											</label>
										</div>
										<div
											v-if="$i18n.locale ==='ru'"
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.company }"
										>
											<DadataCompany
												name="company_name"
												:input-options="{
													placeholder: 'Название компании/организации',
													styleClasses: 'form-control company-input rounded-0 required'
												}"
												:style-classes="'dadata-form rounded-0 required'"
												@setCompanyInfo="setCompanyInfo"
												@updateErrorMessage="updateCompanyErrorMessage"
											/>
											<div v-if="companyErrorMessage" class="error">
												{{ companyErrorMessage }}
											</div>
											<div v-if="form.errors.company" class="error">
												<div v-for="msg in form.errors.company" :key="msg">
													{{ msg }}
												</div>
											</div>
										</div>
										<div
											v-else
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.last_name }"
										>
											<input
												id="company"
												v-model.trim="form.fields.last_name"
												name="last_name"
												placeholder="Company name"
												type="text"
												class="form-control rounded-0 required"
											>
											<label v-if="form.errors.company" class="error" for="company">
												<div v-for="msg in form.errors.company" :key="msg">{{ msg }}</div>
											</label>
										</div>
										<div
											v-if="$i18n.locale ==='ru'"
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.inn }"
										>
											<input
												id="inn"
												v-model.trim="form.fields.inn"
												name="inn"
												placeholder="ИНН организации"
												type="text"
												class="form-control rounded-0 required"
												autocomplete="inn"
												@input="onInnChange"
											>
											<label v-if="form.errors.inn" class="error" for="inn">
												<div v-for="msg in form.errors.inn" :key="msg">{{ msg }}</div>
											</label>
										</div>
										<div
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.email }"
										>
											<input
												id="email"
												v-model.trim="form.fields.email"
												name="email"
												:placeholder="$t('corporateEmail')"
												type="email"
												class="form-control rounded-0 required"
												required
												autocomplete="username"
											>
											<label v-if="form.errors.email" class="error" for="email">
												<div v-for="msg in form.errors.email" :key="msg">{{ msg }}</div>
											</label>
										</div>
										<div
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.password }"
										>
											<input
												id="password"
												v-model.trim="form.fields.password"
												name="password"
												:placeholder="$t('password')"
												type="password"
												class="form-control rounded-0 required"
												required
												autocomplete="new-password"
											>
											<label v-if="form.errors.password" class="error" for="password">
												<div v-for="msg in form.errors.password" :key="msg">{{ msg }}</div>
											</label>
										</div>
										<div
											class="form-group col-12"
											:class="{ 'form-group--error': form.errors.password_confirmation }"
										>
											<input
												id="password_confirmation"
												v-model.trim="form.fields.password_confirmation"
												name="password_confirmation"
												:placeholder="$t('confirmPassword')"
												type="password"
												class="form-control rounded-0 required"
												required
												autocomplete="new-password"
											>
											<label
												v-if="form.errors.password_confirmation"
												class="error"
												for="password_confirmation"
											>
												<div
													v-for="msg in form.errors.password_confirmation"
													:key="msg"
												>{{ msg }}
												</div>
											</label>
										</div>
										<div class="form-group col-12 custom-control custom-checkbox">
											<div class="form-check mb-3">
												<input
													id="accept"
													v-model.trim="agreements.personal_data"
													v-model="form.fields.accept"
													name="accept"
													type="checkbox"
													class="rounded-0 required form-check-input custom-control-input"
													value="personal-data"
													required
													data-action="layout-auth-personal-data-processing-agreement"
												>
												<label class="custom-control-label form-check-label" for="accept">
													{{ $t('agreeWith') }}
													<a
														:href="`https://www.skolkovo.ru/static/personaldata_${$i18n.locale === 'ru' ? 'rus': 'eng'}.html`"
														target="_blank"
													>{{ $t('personalData') }}</a>
													<template v-if="form.errors.accept">
														<div v-for="msg in form.errors.accept" :key="msg">{{
															msg
														}}
														</div>
													</template>
												</label>
											</div>
											<div class="form-check">
												<input
													id="marketing_emails"
													v-model.trim="agreements.marketing_emails"
													name="marketing_emails"
													type="checkbox"
													class="rounded-0 required form-check-input custom-control-input"
													value="marketing-emails"
													data-action="layout-auth-marketing-emails-agreement"
												>
												<label
													class="custom-control-label form-check-label"
													for="marketing_emails"
												>
													{{ $t('isAgreesToMarketingEmails') }}
												</label>
											</div>
										</div>
										<div v-if="featureFlagShowLoyaltyAgreementInCorporateReg" class="form-group col-12 custom-control custom-checkbox">
											<div class="form-check">
												<input
													id="checkbox_loyalty"
													v-model.trim="agreements.loyalty_agreement"
													type="checkbox"
													class="rounded-0 required form-check-input custom-control-input"
													value="personal-data"
												>
												<label
													class="custom-control-label form-check-label"
													for="checkbox_loyalty"
												>
													Отправляя форму, я соглашаюсь стать
													участником Программы лояльности
													Школы и принимаю
													<a href="https://sk.skolkovo.ru/storage/loyalty-legal.pdf">правила участия</a>.
												</label>
											</div>
										</div>
									</div>
									<div class="form-row">
										<div v-if="form.message" class="col-12 overflow-auto message mb-3">
											{{ form.message }}
										</div>
									</div>
									<div class="form-row">
										<div v-if="false" class="col-12">
											<div class="g-recaptcha" data-sitekey="recaptcha" />
										</div>
										<div class="col-12">
											<b-button
												variant="primary"
												type="submit"
												:disabled="form.sending || form.sent || !agreements.personal_data"
											>
												{{ $t('createAccount') }}
											</b-button>
											<span
												v-if="error"
												class="overflow-auto error mb-3"
											>
												{{ error }}
											</span>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</template>
				<template v-if="type === TYPE.RESET_PASSWORD">
					<div class="row d-flex justify-content-center">
						<div class="col-12 col-md-10 col-lg-10">
							<div class="title mb-3">
								{{ $t('resetPassword') }}
							</div>

							<form @submit.prevent="resetPassword">
								<div class="form-row">
									<div
										class="form-group col-6"
										:class="{ 'form-group--error': form.errors.password }"
									>
										<input
											id="password"
											v-model.trim="form.fields.password"
											name="password"
											:placeholder="$t('password')"
											type="password"
											class="form-control rounded-0 required"
											required
											autocomplete="new-password"
										>
										<label v-if="form.errors.password" class="error" for="password">
											<div v-for="msg in form.errors.password" :key="msg">{{ msg }}</div>
										</label>
									</div>
									<div
										class="form-group col-6"
										:class="{ 'form-group--error': form.errors.password_confirmation }"
									>
										<input
											id="password"
											v-model.trim="form.fields.password_confirmation"
											name="password"
											:placeholder="$t('confirmPassword')"
											type="password"
											class="form-control rounded-0 required"
											required
											autocomplete="new-password"
										>
										<label v-if="form.errors.password_confirmation" class="error" for="password">
											<div v-for="msg in form.errors.password_confirmation" :key="msg">{{
												msg
											}}
											</div>
										</label>
									</div>
								</div>

								<div class="form-row">
									<div v-if="false" class="col-12">
										<div class="g-recaptcha" data-sitekey="recaptcha" />
									</div>
									<div class="col-12">
										<b-button
											variant="primary"
											type="submit"
											:disabled="form.sending || form.sent"
										>
											{{ $t('save') }}
										</b-button>
										<span
											v-if="error"
											class="overflow-auto error mb-3"
										>
											{{ error }}
										</span>
									</div>
								</div>
							</form>
						</div>
					</div>
				</template>
			</div>
		</div>
	</b-modal>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { TYPE } from '~/store/authModal';
import DadataCompany from '~/components/daData/DadataCompany.vue';
import agreementsMixin from '~/mixins/agreementsMixin';
import VuePhoneNumberInput from 'vue-phone-number-input';

const LOGIN_TYPES = {
	EMAIL: 1,
	CAMPUS: 2,
	CODE: 3,
};

const REGISTRATION_TYPES = {
	DEFAULT: 1,
	ENTITY: 2,
};

export default {
	components: {
		DadataCompany,
		VuePhoneNumberInput,
	},
	mixins: [agreementsMixin],
	data() {
		return {
			TYPE,
			LOGIN_TYPES,
			REGISTRATION_TYPES,
			stage: 0,
			loginType: LOGIN_TYPES.EMAIL,
			registrationType: null,
			form: {
				fields: {},
				sending: false,
				sent: false,
				message: null,
				error: null,
				errors: {},
				isRegisteredUserRecognized: false,
				isKoiUserRecognized: false,
				showAllLoginsOnError: false,

			},
			countryCode: null,
			isResetPassword: false,
			isMobilePhoneValid: false,
			showPhoneValidationError: false,
			mobilePhoneShort: '',
			companyErrorMessage: '',
			companyInn: '',
		};
	},
	computed: {
		...mapState('authModal', ['type', 'redirectUri', 'client']),
		authType() {
			if (this.type === this.TYPE.LOGIN_SIMPLE_WINDOW) {
				return this.$t('authentication');
			}
			return this.$t('myProfile');
		},
		providers() {
			return [
				{
					name: 'Google',
					link: this.makeProviderUrl('google'),
					class: 'provider-google',
					iconClass: 'icon icon-google',
				},
				{
					name: 'Yandex',
					link: this.makeProviderUrl('yandex'),
					class: 'provider-yandex',
					iconClass: 'icon icon-yandex',
				},
			];
		},
		isVisible: {
			get() {
				return this.$store.state.authModal.isVisible;
			},
			set(visible) {
				this.setIsVisible(visible);
			},
		},
		error() {
			if (this.form.error) {
				if (this.form.error.includes('SQLSTATE[23000]')) {
					return 'Данный email уже зарегистрирован на сайте';
				}

				return this.form.error;
			}

			return this.form.error;
		},
		isModalForSkolkovoId() {
			return this.$route.query.skolkovoId;
		},
		featureFlagShowLoyaltyAgreementInCorporateReg() {
			// TODO [LOYALB2B-40]: Удалить фичя флаг после запуска функционала по B2B
			// Feature flag для тестирования функционала согласия участия в системе лояльности
			// Скрывает галочку согласия на участия в программе лояльности
			// Для отображения галочки: дописать параметр ?b2b_new_register=1 в адресной строке
			const showLoyaltyAgreementCheckbox = this.$route.query.b2b_new_register;
			return showLoyaltyAgreementCheckbox === '1';
		},
		skolkovoIdAuthUrl() {
			return `https://id.skolkovo.ru/login?return_url=${window.location.origin}${this.$route.path}`;
		},
	},
	watch: {
		type() {
			// this.registrationType = null;
			this.form.error = null;
			this.form.errors = {};
			this.form.fields = {};
		},
		'$route.query': {
			handler() {
				this.setRedirectUri(`${this.$route.fullPath}`);
			},
		},
	},
	mounted() {
		this.setRedirectUri(`${this.$route.fullPath}`);
		this.registrationType = this.client;
		this.setResetPasswordScenarioIfIsIt();
	},
	methods: {
		...mapMutations('authModal', ['setIsVisible']),
		...mapActions('authModal', ['showLogin', 'showRegistration', 'setRedirectUri']),
		...mapActions('profile', ['getRoles']),
		showModal() {
			this.isVisible = true;
		},
		hideModal(reload) {
			this.isVisible = false;
			this.form.sent = false;
			if (reload) location.reload();
		},
		showRegistrationForm() {
			this.loginType = null;
			this.registrationType = null;
			this.form.message = null;
			this.form.showAllLoginsOnError = false;
			this.form.error = null;
			this.form.errors = {};
			this.form.sent = false;
			this.form.fields = {};
			this.showRegistration();
		},
		setCompanyInfo(company) {
			if (company.data?.inn) {
				this.form.fields.inn = company.data.inn.trim();
				this.companyInn = company.data.inn.trim();
			} else {
				this.form.fields.inn = null;
			}
			this.form.fields.company = company.value.trim();
			this.$forceUpdate();
		},
		updateCompanyErrorMessage(errorMessage) {
			this.companyErrorMessage = errorMessage;
		},
		onInnChange() {
			if (this.form.fields.company && this.companyInn !== this.form.fields.inn) {
				this.form.fields.company = null;
				this.companyErrorMessage = 'ИНН не соответсвует выбранной компании';
				this.$forceUpdate();
			}
		},
		changeRegistrationType() {
			this.registrationType = null;
			this.isResetPassword = false;
		},
		returnToAuth() {
			this.isResetPassword = false;
			this.form.errors = {};
		},
		phoneUpdate(payload) {
			this.showPhoneValidationError = !payload.isValid;
			this.isMobilePhoneValid = payload.isValid;
			if (!payload.isValid) {
				this.form.fields.phone = null;
			} else {
				this.countryCode = payload.countryCode;
				this.form.fields.phone = payload.formatInternational;
			}
		},
		// eslint-disable-next-line complexity
		async onSubmit() {
			if (!this.isResetPassword) {
				try {
					if (this.form.fields.phone && this.form.fields.phone > 0) {
						// чтобы предзаполненный номер автоматически обработался
						this.$refs.phoneInput.emitValues({
							phoneNumber: this.mobilePhoneShort,
							countryCode: this.countryCode,
						});
					}
					this.form.sending = true;
					if (this.type === TYPE.LOGIN || this.type === TYPE.LOGIN_SIMPLE_WINDOW) {
						if (this.loginType === LOGIN_TYPES.EMAIL) {
							await this.$auth.loginWith('local', {
								data: this.form.fields,
							}).then((res) => {
								if (res.data?.data) {
									window.dataLayer = window.dataLayer || [];
									window.dataLayer.push({
										event: 'login',
										user_id: res.data.data.id,
										counterparty_type: res.data.data.counterparty_type ? 'Корпоративный клиент' : 'Физическое лицо',
									});
								}
							});
						} else if (this.loginType === LOGIN_TYPES.CODE) {
							let token = null;
							let user = null;
							await this.$api.codeLogin(
								{
									...this.form.fields,
								},
							).then((res) => {
								if (res.data) {
									window.dataLayer = window.dataLayer || [];
									window.dataLayer.push({
										event: 'login',
										user_id: res.data.id,
										counterparty_type: res.data.counterparty_type ? 'Корпоративный клиент' : 'Физическое лицо',
									});
								}
								token = res.token;
								user = res.data;
							});

							await this.$auth.setStrategy('local');
							this.$auth.setUserToken(token.access_token);
							this.$auth.setUser(user);

							this.$auth.setRefreshToken('local', token.refresh_token);
						}
					} else if (this.registrationType === REGISTRATION_TYPES.DEFAULT) {
						this.showPhoneValidationError = false;
						if (!this.isMobilePhoneValid) {
							this.showPhoneValidationError = true;
						}
						const clientID = typeof yaCounter994527 !== 'undefined'
							? yaCounter994527.getClientID()
							: '';
						const { UAClientID } = window;
						const BpmRef = this.$cookies.get('bpmRef') || '';
						const BpmHref = this.$cookies.get('bpmHref') || '';
						const roistatVisitId = this.$cookies.get('roistat_visit') || '';

						let token = null;
						let user = null;
						await this.$api.register(
							{
								...this.form.fields,
								redirect_uri: this.redirectUri,
								SkGAClientId:
									typeof UAClientID !== 'undefined' ? UAClientID : '',
								SkYMClientId:
									typeof clientID !== 'undefined' ? clientID : '',
								roistatVisitId:
									typeof roistatVisitId !== 'undefined' ? roistatVisitId : '',
								BpmRef,
								BpmHref,
								sklTargetAction: 'Регистрация ЛК',
								sklAgreeSubscribeLookup: this.agreements.marketing_emails ? 'да' : 'нет',
							},
						).then((res) => {
							if (res.data) {
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({
									event: 'sign_up',
									user_id: res.data.id,
									counterparty_type: 'Физическое лицо',
								});
							}
							token = res.token;
							user = res.data;
						});

						await this.$auth.setStrategy('local');
						this.$auth.setUserToken(token.access_token);
						this.$auth.setUser(user);
						this.setAgreementFields();

						this.$auth.setRefreshToken('local', token.refresh_token);
					} else {
						const clientID = typeof yaCounter994527 !== 'undefined'
							? yaCounter994527.getClientID()
							: '';
						const { UAClientID } = window;
						const BpmRef = this.$cookies.get('bpmRef') || '';
						const BpmHref = this.$cookies.get('bpmHref') || '';
						const roistatVisitId = this.$cookies.get('roistat_visit') || '';

						let token = null;
						let user = null;
						await this.$api.registerCorporate(
							{
								...this.form.fields,
								redirect_uri: this.redirectUri,
								SkGAClientId:
									typeof UAClientID !== 'undefined' ? UAClientID : '',
								SkYMClientId:
									typeof clientID !== 'undefined' ? clientID : '',
								roistatVisitId:
									typeof roistatVisitId !== 'undefined' ? roistatVisitId : '',
								BpmRef,
								BpmHref,
								sklTargetAction: 'Регистрация ЛК',
								sklAgreeSubscribeLookup: this.agreements.marketing_emails ? 'да' : 'нет',
							},
						).then((res) => {
							if (res.data) {
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({
									event: 'sign_up',
									user_id: res.data.id,
									counterparty_type: 'Корпоративный клиент',
								});
							}
							token = res.token;
							user = res.data;
						});

						await this.$auth.setStrategy('local');
						this.$auth.setUserToken(token.access_token);
						this.$auth.setUser(user);
						this.setAgreementFields();

						this.$auth.setRefreshToken('local', token.refresh_token);
					}

					this.form.message = null;
					this.form.showAllLoginsOnError = false;
					this.form.error = null;
					this.form.errors = {};
					this.form.sent = true;
					this.form.fields = {};

					// this.$auth.$storage.setUniversal('redirect', null);

					this.hideModal(this.$store.state.authModal.needReload);

					this.form.isRegisteredUserRecognized = false;
					this.loginType = null;
					this.registrationType = null;

					if (this.$route.query.redirect_to) {
						this.$router.push(this.$route.query.redirect_to);
					}
				} catch (error) {
					this.form.message = null;
					try {
						const {
							message,
							errors,
						} = this.$api.getValidationFromError(error);
						this.form.error = message;
						this.form.errors = errors;
					} catch {
						this.$logger.exception(error, 'onSubmit', this);
						this.form.error = 'Что-то пошло не так';
						this.form.errors = {};
					}
				} finally {
					this.form.sending = false;
					this.getRoles();
				}
			}
		},
		async recognizeUser() {
			this.form.sending = true;
			try {
				const isUserRegistered = await this.$api.isUserRegistered({
					email: this.form.fields.email,
				});
				if (isUserRegistered) {
					this.form.isRegisteredUserRecognized = true;
					this.form.message = null;
					this.form.showAllLoginsOnError = false;
					this.form.error = null;
					this.form.errors = {};
					return;
				}

				const koiData = new FormData();
				koiData.set(
					'data',
					JSON.stringify({
						email: this.form.fields.email,
					}),
				);
				const koiDbResponse = await this.$api.koiDbRecognize(koiData);
				if (
					koiDbResponse.need_additional_info === false
					&& (koiDbResponse.user_id_found === true
						|| koiDbResponse.contact_id_found === true)
				) {
					this.form.message = 'Чтобы подтвердить почтовый адрес, перейдите по ссылке, которую мы отправим на ваш e-mail.';
					this.form.isKoiUserRecognized = true;
					// this.showRequestButton = true;
				} else if (koiDbResponse.need_additional_info === true) {
					// нужна фамилия
				} else {
					this.form.showAllLoginsOnError = true;
					this.form.message = 'Мы не нашли указанный email. Возможно, вы ввели неправильно пароль. Пожалуйста, используйте другие email и пароль, либо ';
				}
				this.form.error = null;
				this.form.errors = {};
				this.form.sent = false;
			} catch (error) {
				this.form.message = null;
				try {
					const {
						message,
						errors,
					} = this.$api.getValidationFromError(error);
					this.form.error = message;
					this.form.errors = errors;
				} catch {
					this.form.error = 'Что-то пошло не так';
					this.form.errors = {};
				}
			} finally {
				this.form.sending = false;
			}
		},
		async sendRecognitionEmail() {
			this.form.sending = true;
			try {
				const { email } = this.form.fields;
				await this.$api.requestRecognitionVerification({
					type: 'email',
					email,
				});
				this.form.message = `Мы отправили ссылку на почту ${email}. Перейдите по ссылке, чтобы завершить подтверждение.`;
				this.form.error = null;
				this.form.errors = {};
				this.form.sent = true;
			} catch (error) {
				this.form.message = null;
				try {
					const {
						message,
						errors,
					} = this.$api.getValidationFromError(error);
					this.form.error = message;
					this.form.errors = errors;
				} catch {
					this.form.error = 'Что-то пошло не так';
					this.form.errors = {};
				}
			} finally {
				this.form.sending = false;
			}
		},
		makeProviderUrl(provider) {
			const baseFrontendURL = process.env.baseFrontendURL.endsWith('/') ? process.env.baseFrontendURL.slice(0, -1) : process.env.baseFrontendURL;
			const redirectUri = baseFrontendURL + this.$route.path;
			return `${process.env.baseApiUrl}/social/redirect/${provider}?redirect_uri=${encodeURIComponent(redirectUri)}`;
		},
		toggleToResetPassword() {
			this.isResetPassword = true;
			this.form.message = null;
		},
		toggleLogin(type = LOGIN_TYPES.EMAIL, stage = 0) {
			this.loginType = type;
			this.stage = stage;
			this.form.message = null;
		},
		async forgotPassword() {
			try {
				this.form.sending = true;

				const { email } = this.form.fields;

				const response = await this.$api.forgotPassword({ email });
				const { status } = response;

				this.form.message = status;
				this.form.error = null;
				this.form.errors = {};
				this.form.sent = true;
				this.isResetPassword = false;
				this.form.fields.password = '';
			} catch (error) {
				this.form.message = null;
				try {
					const {
						message,
						errors,
					} = this.$api.getValidationFromError(error);
					this.form.error = message;
					this.form.errors = errors;
				} catch {
					console.error(error);
					this.form.error = 'Что-то пошло не так';
					this.form.errors = {};
				}
			} finally {
				this.form.sending = false;
			}
		},
		async codeGenerate() {
			if (!this.form.sending) {
				try {
					this.form.sending = true;

					const { email } = this.form.fields;

					const response = await this.$api.codeGenerate({ email });
					const { status } = response;

					this.form.message = status;
					this.form.error = null;
					this.form.errors = {};
					this.form.sent = true;
					this.isResetPassword = false;
					this.form.fields.password = '';

					this.stage = 1;
				} catch (error) {
					this.form.message = null;
					try {
						const {
							message,
							errors,
						} = this.$api.getValidationFromError(error);
						this.form.error = message;
						this.form.errors = errors;
					} catch {
						console.error(error);
						this.form.error = 'Что-то пошло не так';
						this.form.errors = {};
					}
				} finally {
					this.form.sending = false;
				}
			}
		},
		valid(field) {
			if (this.form.errors[field] === undefined) return null;
			return !this.form.errors[field];
		},
		setResetPasswordScenarioIfIsIt() {
			const { resetPassword, token, email } = this.$route.query;

			if (resetPassword && token && email) {
				this.type = TYPE.RESET_PASSWORD;
			}
		},
		async resetPassword() {
			const { resetPassword, token, email } = this.$route.query;

			if (resetPassword && token && email) {
				try {
					this.form.sending = true;

					const { password, password_confirmation } = this.form.fields;

					const { token: userToken, data: user, status } = await this.$api.resetPassword({
						email, token, password, password_confirmation,
					});

					await this.$auth.setStrategy('local');
					this.$auth.setUserToken(userToken.access_token);
					this.$auth.setUser(user);

					this.$auth.setRefreshToken('local', userToken.refresh_token);

					this.form.message = status;
					this.form.error = null;
					this.form.errors = {};
					this.form.sent = true;
					this.isResetPassword = false;
					this.form.fields.password = '';
					this.hideModal();
					await this.$router.replace({ query: null });
				} catch (error) {
					this.form.message = null;
					try {
						const {
							message,
							errors,
						} = this.$api.getValidationFromError(error);
						this.form.error = message;
						this.form.errors = errors;
					} catch {
						console.error(error);
						this.form.error = 'Что-то пошло не так';
						this.form.errors = {};
					}
				} finally {
					this.form.sending = false;
				}
			}
		},
		personRegisterHandler() {
			if (this.isModalForSkolkovoId) {
				window.location.replace('https://id.skolkovo.ru/register?return_url=https://www.skolkovo.ru/');
				return;
			}
			this.registrationType = REGISTRATION_TYPES.DEFAULT;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "/assets/styles/components/dev/auth.scss";

input {
	color: $body-color;
	&::placeholder {
		color: $border-color  !important;
	}
}

</style>

<style lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.auth-form {
	& .company-input {
		border-left: 0 !important;
		border-right: 0 !important;
		border-top: 0 !important;

		&::placeholder {
			color: $border-color !important;
		}
	}
}

.auth-phone-class {
	.input-tel__label {
		top: -8px !important;
	}

	.country-selector.no-flags {
		.country-selector__input {
			padding-left: 0 !important;
		}
	}

	.vue-phone-number-input {

		.input-tel__input,
		.country-selector__input {
			background-color: transparent !important;
			border: 0 !important;
			border-bottom: 1px solid $body-color !important;
			box-shadow: none !important;
			height: calc(1.5em + 0.75rem + 2px) !important;
			font-size: 1rem !important;
			padding: 0.375rem 1.2rem !important;

			&::placeholder {
				color: $border-color !important;
			}
		}

		.input-tel__input {
			color: $body-color !important;
		}

		.country-selector__toggle__arrow {
			color: $border-color !important;
			fill: $border-color !important;

			path.arrow {
				color: $border-color !important;
				fill: $border-color !important;
			}
		}
	}

	.dadata-form {
		& input {
			border-width: 0 0 1px 0 !important;
			height: calc(1.5em + 0.75rem + 2px);
			padding: 0.375rem 0 !important;
			&::placeholder {
				color: $border-color !important;
				opacity: 1;
			}
		}
	}
}

input[type="date"]::before {
	content: attr(placeholder);
	color: $border-color;
	width: 100%;
}

input[type="date"]:focus::before,
input[type="date"]:valid::before {
	display: none;
}

.cookie-error {
	width: 100%;
	font-size: 100%;
	color: #dc3545;
}

</style>
